module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-zoom"
  }, [_c('div', {
    staticClass: "good-zoom-container"
  }, [_c('div', {
    staticClass: "zoom"
  }, [(_vm.image) ? _c('img', {
    attrs: {
      "src": _vm.image.raw + '?w=500&h=500'
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.altUrlSmall
    }
  })]), _vm._v(" "), (_vm.item.images && _vm.item.images.length > 1) ? _c('ul', {
    staticClass: "images"
  }, [_vm._l((_vm.item.images), function(image) {
    return [_c('li', {
      style: ({
        backgroundImage: ("url('" + (image.raw) + "')")
      }),
      on: {
        "click": function($event) {
          return _vm.showImage(image)
        }
      }
    })]
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5563d8ff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodZoom.vue
// module id = 345
// module chunks = 1